function Title({ children }: { children: string }) {
  return (
    <p className="text-baseBlack text-2xl font-bold leading-[30px]">
      {children}
    </p>
  );
}

export default Title;
